import { Star, UserCheck, AlertCircle, XCircle } from "lucide-react"
import { CategoryInfo } from '../applicantsTable/customTypes';


export const ITEMS_PER_PAGE = 20

export const CANDIDATE_CATEGORIES: Record<string, CategoryInfo> = {
  SuperCandidate: {
    color: "border-l-4 border-l-green-500",
    textColor: "text-green-700",
    icon: <Star className="h-5 w-5 text-yellow-500 fill-yellow-500" />,
    priority: 1,
    badge: "bg-green-600 text-white hover:bg-green-700",
    description: "Extraordinary match - Contact immediately",
  },
  "Top Candidate": {
    color: "border-l-4 border-l-blue-500",
    textColor: "text-blue-700",
    icon: <UserCheck className="h-5 w-5 text-blue-500" />,
    priority: 2,
    badge: "bg-blue-600 text-white hover:bg-blue-700",
    description: "Qualified for role",
  },
  "No Match": {
    color: "border-l-4 border-l-gray-400",
    textColor: "text-gray-700",
    icon: <AlertCircle className="h-5 w-5 text-gray-500" />,
    priority: 3,
    badge: "bg-gray-600 text-white hover:bg-gray-700",
    description: "Not qualified for role",
  },
  "Failed pre-qualification": {
    color: "border-l-4 border-l-red-500",
    textColor: "text-red-700",
    icon: <XCircle className="h-5 w-5 text-red-500" />,
    priority: 4,
    badge: "bg-red-600 text-white hover:bg-red-700",
    description: "Failed pre-qualification",
  },
}
